import { Component, ChangeDetectionStrategy, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';

import { ConfirmDialogService } from '@mode/shared/ui';
import { OrgTypes, UserTypes } from '@mode/shared/contract-common';
import { getAppName } from '@mode/shared/util-js';

@Component({
  selector: 'mode-context-dialog',
  templateUrl: './context-dialog.component.html',
  styleUrls: ['./context-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextDialogComponent implements OnInit {
  hideClose = false;
  readonly appName = getAppName();

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA)
    public data: {
      currentOrg: OrgTypes.Organization;
      currentUser: UserTypes.User;
      userOrgs$: Observable<OrgTypes.Organization>;
      isUserOrgsLoading$: Observable<boolean>;
      isUserOrgsComplete$: Observable<boolean>;
      hasMemberOrgs$: Observable<boolean>;
      connectDatabaseElementId?: string;
    },
    public dialogRef: MatLegacyDialogRef<ContextDialogComponent>,
    private confirmDialogService: ConfirmDialogService
  ) {}

  ngOnInit(): void {
    // for this component, disabling default close actions should also hide the close button
    // grab the property from the dialogRef and pass it to the header
    this.hideClose = !!this.dialogRef.disableClose;
  }

  confirmNewStudioWorkspace() {
    this.confirmDialogService.open({
      dialogTitle: `Switch to Mode Studio`,
      dialogText: `Before you connect a database, you'll need to create a free Mode Studio workspace. This will let you query and share data privately with others. You can return to the ${this.appName} Community at any point.`,
      confirmText: `Create Mode Studio workspace`,
      cancelText: 'Back',
      confirmAction: () => this.goToNewWorkspace(),
    });
  }

  confirmNewWorkspace() {
    this.confirmDialogService.open({
      dialogTitle: 'Creating a Workspace',
      dialogText:
        "Workspaces allow companies and other groups to share data and analysis privately.\n\nDatabases connected to Workspaces can be queried by everyone in the Workspace. For more information on connecting databases to your Workspace, see Connecting to Databases.\n\nReports, Definitions, and Spaces created using Workspace databases can be shared and run by everyone in the Workspace, depending on how permissions are set by the Workspace's admin.",
      confirmText: 'Create new Workspace',
      confirmButtonColor: 'alert',
      cancelText: 'Back',
      confirmAction: () => this.goToNewWorkspace(),
    });
  }

  goToNewWorkspace() {
    // handle navigation to organizations/new
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: TS2322
    window.location.href = this.data.currentOrg.links.newOrganization;
  }
}
